(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7959],{

/***/ 31777:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketing-preferences/tfs",
      function () {
        return __webpack_require__(64464);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _components_form_fields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68143);
/* harmony import */ var _components_form_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76817);
/* harmony import */ var _components_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98655);
/* harmony import */ var _contexts_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28798);
/* harmony import */ var _hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97859);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47392);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45911);
/* harmony import */ var _utils_helpers_tracking__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68379);
/* harmony import */ var _utils_schemas__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73705);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46392);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(82684);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75367);
/* harmony import */ var upper_case_first__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85298);














const TFS = (param)=>{
    let { content , tracking , brand , query  } = param;
    const campaign = (0,_contexts_index__WEBPACK_IMPORTED_MODULE_4__/* .useCampaign */ .yQ)();
    const [submitResponse, setSubmitResponse] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)("");
    const initialValues = {
        first_name: "",
        last_name: "",
        email: "",
        confirm_email: "",
        agreement_or_reg_num: "",
        communication_relevantoffers: "",
        contact_phone: "",
        contact_email: "",
        contact_sms: "",
        contact_post: "",
        consent: {
            user: false
        },
        unsubscribe: [],
        response_code: "",
        campaign_response_code: "",
        campaign_code: "",
        is_lexus: brand === "lexus"
    };
    const methods = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_11__/* .useForm */ .cI)({
        resolver: (0,_hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_12__/* .yupResolver */ .X)(_utils_schemas__WEBPACK_IMPORTED_MODULE_8__/* .MarketingPreferencesSchema */ .c0),
        defaultValues: initialValues,
        mode: "onTouched"
    });
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        if (campaign === null || campaign === void 0 ? void 0 : campaign.campaign) {
            methods.setValue("campaign_code", campaign.campaign);
        }
        if (campaign === null || campaign === void 0 ? void 0 : campaign.media) {
            const code = methods.getValues("campaign_code");
            methods.setValue("campaign_code", code + campaign.media);
        }
        if (campaign === null || campaign === void 0 ? void 0 : campaign.brochure) {
            methods.setValue("campaign_response_code", campaign.brochure);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        campaign
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        if (query === null || query === void 0 ? void 0 : query.email) {
            methods.setValue("email", query.email);
            methods.setValue("confirm_email", query.email);
        }
        if (query === null || query === void 0 ? void 0 : query.title) {
            methods.setValue("title", query.title);
        }
        if ((query === null || query === void 0 ? void 0 : query.firstname) || (query === null || query === void 0 ? void 0 : query.first_name)) {
            methods.setValue("first_name", query.firstname || query.first_name);
        }
        if ((query === null || query === void 0 ? void 0 : query.lastname) || (query === null || query === void 0 ? void 0 : query.last_name)) {
            methods.setValue("last_name", query.lastname || query.last_name);
        }
    }, [
        query
    ]);
    const onSubmit = async (data)=>{
        const formData = data;
        await (0,axios__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)({
            method: "post",
            url: "".concat("https://api.toyota.co.uk/forms/api", "/marketing-preferences"),
            headers: {
                "Content-Type": "application/json"
            },
            data: formData
        }).then(()=>{
            (0,_utils_helpers_tracking__WEBPACK_IMPORTED_MODULE_7__/* .formEvent */ .Be)({
                conversion: 1,
                name: tracking.form,
                step: "form-submit",
                variant: "",
                page: tracking.page
            });
            (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_6__/* .closeOverlay */ .Km)(content.confirmation.title, content.confirmation.copy, setSubmitResponse);
        }).catch(()=>{
            (0,_utils_helpers_tracking__WEBPACK_IMPORTED_MODULE_7__/* .formEvent */ .Be)({
                conversion: 0,
                name: tracking.form,
                step: "form-error",
                variant: "",
                page: tracking.page
            });
            setSubmitResponse(_utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .ERROR_MESSAGE */ .c9);
            throw new Error(_utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .ERROR_MESSAGE */ .c9);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui__WEBPACK_IMPORTED_MODULE_3__/* .Nav */ .JL, {
                title: content.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_layout__WEBPACK_IMPORTED_MODULE_2__/* .FormWrapper */ .n, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_layout__WEBPACK_IMPORTED_MODULE_2__/* .FormStep */ .p, {
                    title: content.details.title,
                    subtitle: content.details.subtitle,
                    step: 1,
                    active: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_11__/* .FormProvider */ .RV, {
                        ...methods,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                            onSubmit: methods.handleSubmit(onSubmit),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .AuthFill */ .Pl, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .FirstName */ .SW, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .LastName */ .uQ, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Email */ .GT, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .AgreementNo */ .Se, {
                                    label: "Agreement / Proposal Number "
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .CommunicationsPreferences */ .Ew, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .ContactPreferences */ .j8, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .PreferenceTerms */ .fK, {
                                    preferenceType: "".concat((0,upper_case_first__WEBPACK_IMPORTED_MODULE_13__/* .upperCaseFirst */ .l)(brand), " Financial Services")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                    submitResponse: submitResponse,
                                    children: content.details.submit
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
TFS.whyDidYouRender = true;
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (TFS);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7409,1850,9595,9516,8655,4817,9774,2888,179], function() { return __webpack_exec__(31777); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);